import type { SvgIconProps } from "@mui/material";

const ConversationIcon = (props: SvgIconProps) => {
  return (
    <svg
      width="53"
      height="53"
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.40137 5.2959C9.21132 5.2959 10.0038 5.5342 10.6797 5.98047C11.3555 6.42673 11.885 7.06187 12.2031 7.80664C12.5213 8.55142 12.6146 9.3731 12.4697 10.1699C12.3248 10.9668 11.9487 11.7039 11.3887 12.2891L11.3291 12.3506L11.4043 12.3916C12.3816 12.9287 13.1973 13.7183 13.7656 14.6777C14.334 15.6372 14.6342 16.7316 14.6357 17.8467V20.9971C14.6357 21.815 14.3108 22.5994 13.7324 23.1777C13.154 23.7561 12.3697 24.081 11.5518 24.0811H5.25195C4.43393 24.0811 3.64874 23.7562 3.07031 23.1777C2.49204 22.5994 2.16708 21.8149 2.16699 20.9971V17.8467C2.16853 16.7315 2.46974 15.6372 3.03809 14.6777C3.60643 13.7184 4.42128 12.9287 5.39844 12.3916L5.47363 12.3506L5.41406 12.2891C4.85414 11.7039 4.47885 10.9668 4.33398 10.1699C4.18913 9.37312 4.28151 8.55141 4.59961 7.80664C4.91778 7.0618 5.44811 6.42674 6.12402 5.98047C6.79984 5.53433 7.59157 5.29594 8.40137 5.2959ZM8.40137 13.5811C7.27032 13.5811 6.18562 14.0304 5.38574 14.8301C4.58579 15.63 4.13575 16.7154 4.13574 17.8467V20.9971C4.13583 21.2928 4.25383 21.576 4.46289 21.7852C4.67211 21.9944 4.95607 22.1123 5.25195 22.1123H11.5518C11.8476 22.1123 12.1316 21.9943 12.3408 21.7852C12.5497 21.5761 12.6669 21.2926 12.667 20.9971V17.8467C12.667 16.7154 12.2179 15.63 11.418 14.8301C10.618 14.0302 9.53262 13.5811 8.40137 13.5811ZM8.82422 7.32227C8.40422 7.23872 7.96889 7.28246 7.57324 7.44629C7.17757 7.61018 6.83854 7.88709 6.60059 8.24316C6.36271 8.59918 6.23641 9.01812 6.23633 9.44629C6.23633 10.0206 6.46398 10.5724 6.87012 10.9785C7.27619 11.3845 7.82716 11.6123 8.40137 11.6123C8.82968 11.6123 9.24836 11.485 9.60449 11.2471C9.96063 11.0091 10.2384 10.6711 10.4023 10.2754C10.5662 9.87974 10.6089 9.44444 10.5254 9.02441C10.4418 8.60432 10.2355 8.21791 9.93262 7.91504C9.62981 7.61236 9.24413 7.40581 8.82422 7.32227Z"
        fill="url(#paint0_radial_6612_10854)"
        stroke="url(#paint1_linear_6612_10854)"
        stroke-width="0.13125"
      />
      <path
        d="M22.0527 4.13574C21.757 4.13585 21.4738 4.25382 21.2646 4.46289C21.0554 4.67211 20.9375 4.95607 20.9375 5.25195V7.35156C20.9375 7.50438 20.9023 7.65531 20.834 7.79199C20.7657 7.92856 20.6661 8.04701 20.5439 8.13867L17.4668 10.4492L17.3975 10.502L17.4668 10.5537L20.5439 12.8643C20.6661 12.9559 20.7657 13.0744 20.834 13.2109C20.9023 13.3476 20.9375 13.4986 20.9375 13.6514V22.0518C20.9376 22.3476 21.0555 22.6316 21.2646 22.8408C21.4737 23.0497 21.7572 23.1669 22.0527 23.167H47.2529C47.5487 23.167 47.8328 23.0499 48.042 22.8408C48.2512 22.6316 48.3691 22.3476 48.3691 22.0518V5.25195C48.3691 4.95612 48.2511 4.6721 48.042 4.46289C47.8328 4.25367 47.5488 4.13574 47.2529 4.13574H22.0527ZM18.9688 14.1436L18.9424 14.124L15.1621 11.2891C15.04 11.1974 14.9413 11.078 14.873 10.9414C14.8048 10.8049 14.7686 10.6546 14.7686 10.502C14.7686 10.3491 14.8047 10.1982 14.873 10.0615C14.9414 9.9249 15.0399 9.80554 15.1621 9.71387L18.9424 6.87891L18.9688 6.85938V5.25195C18.9688 4.43393 19.2936 3.64875 19.8721 3.07031C20.4504 2.49203 21.2349 2.1671 22.0527 2.16699H47.2529C48.071 2.16699 48.8561 2.49188 49.4346 3.07031C50.0129 3.64874 50.3379 4.43397 50.3379 5.25195V22.0518C50.3378 22.8696 50.0128 23.6541 49.4346 24.2324C48.8561 24.8109 48.071 25.1357 47.2529 25.1357H22.0527C21.2348 25.1356 20.4504 24.8108 19.8721 24.2324C19.2937 23.654 18.9688 22.8697 18.9688 22.0518V14.1436Z"
        fill="url(#paint2_radial_6612_10854)"
        stroke="url(#paint3_linear_6612_10854)"
        stroke-width="0.13125"
      />
      <path
        d="M44.1006 30.499C44.9105 30.499 45.703 30.7373 46.3789 31.1836C47.0547 31.6299 47.5842 32.265 47.9023 33.0098C48.2205 33.7545 48.3138 34.5762 48.1689 35.373C48.0241 36.1699 47.6479 36.907 47.0879 37.4922L47.0283 37.5537L47.1035 37.5947C48.0808 38.1319 48.8965 38.9214 49.4648 39.8809C50.0332 40.8403 50.3334 41.9347 50.335 43.0498V46.2002C50.3349 47.0181 50.01 47.8025 49.4316 48.3809C48.8533 48.9592 48.0689 49.2841 47.251 49.2842H40.9512C40.1331 49.2842 39.348 48.9593 38.7695 48.3809C38.1913 47.8025 37.8663 47.018 37.8662 46.2002V43.0498C37.8677 41.9347 38.169 40.8403 38.7373 39.8809C39.3056 38.9215 40.1205 38.1318 41.0977 37.5947L41.1729 37.5537L41.1133 37.4922C40.5534 36.907 40.1781 36.1699 40.0332 35.373C39.8884 34.5762 39.9807 33.7545 40.2988 33.0098C40.617 32.2649 41.1473 31.6299 41.8232 31.1836C42.4991 30.7375 43.2908 30.4991 44.1006 30.499ZM44.1006 38.7842C42.9695 38.7842 41.8848 39.2335 41.085 40.0332C40.285 40.8332 39.835 41.9185 39.835 43.0498V46.2002C39.8351 46.4959 39.953 46.7792 40.1621 46.9883C40.3713 47.1975 40.6553 47.3154 40.9512 47.3154H47.251C47.5468 47.3154 47.8309 47.1975 48.04 46.9883C48.2489 46.7792 48.3661 46.4958 48.3662 46.2002V43.0498C48.3662 41.9185 47.9171 40.8332 47.1172 40.0332C46.3172 39.2333 45.2318 38.7842 44.1006 38.7842ZM44.5234 32.5254C44.1034 32.4418 43.6681 32.4856 43.2725 32.6494C42.8768 32.8133 42.5378 33.0902 42.2998 33.4463C42.0619 33.8023 41.9356 34.2212 41.9355 34.6494C41.9355 35.2238 42.1632 35.7755 42.5693 36.1816C42.9754 36.5876 43.5264 36.8154 44.1006 36.8154C44.5289 36.8154 44.9476 36.6882 45.3037 36.4502C45.6598 36.2122 45.9377 35.8742 46.1016 35.4785C46.2654 35.0829 46.3081 34.6476 46.2246 34.2275C46.141 33.8074 45.9347 33.421 45.6318 33.1182C45.329 32.8155 44.9434 32.6089 44.5234 32.5254Z"
        fill="url(#paint4_radial_6612_10854)"
        stroke="url(#paint5_linear_6612_10854)"
        stroke-width="0.13125"
      />
      <path
        d="M5.25195 27.3662H30.4512C31.2692 27.3662 32.0544 27.6911 32.6328 28.2695C33.2112 28.848 33.5361 29.6331 33.5361 30.4512V32.0586L33.5625 32.0781L37.3418 34.9131C37.4641 35.0048 37.5635 35.1241 37.6318 35.2607C37.7002 35.3974 37.7363 35.5484 37.7363 35.7012C37.7363 35.8538 37.7 36.0041 37.6318 36.1406C37.5635 36.2773 37.4641 36.3966 37.3418 36.4883L33.5625 39.3232L33.5361 39.3428V47.251C33.5361 48.0688 33.2111 48.8533 32.6328 49.4316C32.0544 50.0101 31.2692 50.335 30.4512 50.335H5.25195C4.43393 50.335 3.64875 50.0101 3.07031 49.4316C2.49205 48.8533 2.16704 48.0688 2.16699 47.251V30.4512C2.16699 29.6331 2.49188 28.848 3.07031 28.2695C3.64875 27.6911 4.43393 27.3662 5.25195 27.3662ZM5.25195 29.335C4.95607 29.335 4.67211 29.4529 4.46289 29.6621C4.25367 29.8713 4.13574 30.1553 4.13574 30.4512V47.251C4.13579 47.5468 4.25372 47.8309 4.46289 48.04C4.67208 48.2491 4.95621 48.3662 5.25195 48.3662H30.4512C30.7469 48.3662 31.031 48.2491 31.2402 48.04C31.4494 47.8309 31.5673 47.5468 31.5674 47.251V38.8506C31.5674 38.6978 31.6026 38.5468 31.6709 38.4102C31.7222 38.3076 31.7913 38.2153 31.874 38.1367L31.9609 38.0635L35.0371 35.7529L35.1074 35.7012L35.0371 35.6484L31.9609 33.3379C31.8388 33.2462 31.7392 33.1278 31.6709 32.9912C31.6026 32.8545 31.5674 32.7036 31.5674 32.5508V30.4512C31.5674 30.1553 31.4495 29.8713 31.2402 29.6621C31.031 29.4529 30.7471 29.335 30.4512 29.335H5.25195Z"
        fill="url(#paint6_radial_6612_10854)"
        stroke="url(#paint7_linear_6612_10854)"
        stroke-width="0.13125"
      />
      <path
        d="M25.2021 7.41699H29.4023C29.6634 7.41699 29.914 7.52053 30.0986 7.70508C30.2832 7.88964 30.3867 8.14036 30.3867 8.40137C30.3867 8.66239 30.2832 8.91306 30.0986 9.09766C29.914 9.28226 29.6634 9.38574 29.4023 9.38574H25.2021C24.9411 9.38569 24.6904 9.28222 24.5059 9.09766C24.3214 8.91307 24.2178 8.66235 24.2178 8.40137C24.2178 8.14036 24.3213 7.88964 24.5059 7.70508C24.6904 7.52052 24.9411 7.41704 25.2021 7.41699Z"
        fill="url(#paint8_radial_6612_10854)"
        stroke="url(#paint9_linear_6612_10854)"
        stroke-width="0.13125"
      />
      <path
        d="M25.2021 12.667H44.1025C44.3635 12.667 44.6143 12.7705 44.7988 12.9551C44.9834 13.1396 45.0869 13.3904 45.0869 13.6514C45.0869 13.9123 44.9833 14.1631 44.7988 14.3477C44.6143 14.5322 44.3635 14.6357 44.1025 14.6357H25.2021C24.9411 14.6357 24.6904 14.5322 24.5059 14.3477C24.3214 14.1631 24.2178 13.9123 24.2178 13.6514C24.2178 13.3904 24.3213 13.1396 24.5059 12.9551C24.6904 12.7705 24.9411 12.667 25.2021 12.667Z"
        fill="url(#paint10_radial_6612_10854)"
        stroke="url(#paint11_linear_6612_10854)"
        stroke-width="0.13125"
      />
      <path
        d="M25.2021 17.917H44.1025C44.3635 17.917 44.6143 18.0205 44.7988 18.2051C44.9834 18.3896 45.0869 18.6404 45.0869 18.9014C45.0869 19.1623 44.9833 19.4131 44.7988 19.5977C44.6143 19.7822 44.3635 19.8857 44.1025 19.8857H25.2021C24.9411 19.8857 24.6904 19.7822 24.5059 19.5977C24.3214 19.4131 24.2178 19.1623 24.2178 18.9014C24.2178 18.6404 24.3213 18.3896 24.5059 18.2051C24.6904 18.0205 24.9411 17.917 25.2021 17.917Z"
        fill="url(#paint12_radial_6612_10854)"
        stroke="url(#paint13_linear_6612_10854)"
        stroke-width="0.13125"
      />
      <path
        d="M23.1006 32.6162H27.3008C27.5618 32.6162 27.8125 32.7198 27.9971 32.9043C28.1816 33.0889 28.2851 33.3396 28.2852 33.6006C28.2852 33.8616 28.1816 34.1123 27.9971 34.2969C27.8125 34.4815 27.5619 34.585 27.3008 34.585H23.1006C22.8396 34.5849 22.5889 34.4814 22.4043 34.2969C22.2198 34.1123 22.1162 33.8616 22.1162 33.6006C22.1163 33.3396 22.2197 33.0889 22.4043 32.9043C22.5889 32.7197 22.8396 32.6163 23.1006 32.6162Z"
        fill="url(#paint14_radial_6612_10854)"
        stroke="url(#paint15_linear_6612_10854)"
        stroke-width="0.13125"
      />
      <path
        d="M8.40137 37.8662H27.3018C27.5628 37.8663 27.8135 37.9697 27.998 38.1543C28.1826 38.3389 28.2861 38.5896 28.2861 38.8506C28.2861 39.1116 28.1825 39.3623 27.998 39.5469C27.8135 39.7314 27.5628 39.8349 27.3018 39.835H8.40137C8.14037 39.8349 7.88964 39.7314 7.70508 39.5469C7.52059 39.3623 7.41699 39.1116 7.41699 38.8506C7.41704 38.5896 7.52052 38.3389 7.70508 38.1543C7.88964 37.9697 8.14036 37.8663 8.40137 37.8662Z"
        fill="url(#paint16_radial_6612_10854)"
        stroke="url(#paint17_linear_6612_10854)"
        stroke-width="0.13125"
      />
      <path
        d="M8.40137 43.1162H27.3018C27.5628 43.1163 27.8135 43.2197 27.998 43.4043C28.1826 43.5889 28.2861 43.8396 28.2861 44.1006C28.2861 44.3616 28.1825 44.6123 27.998 44.7969C27.8135 44.9814 27.5628 45.0849 27.3018 45.085H8.40137C8.14037 45.0849 7.88964 44.9814 7.70508 44.7969C7.52059 44.6123 7.41699 44.3616 7.41699 44.1006C7.41704 43.8396 7.52052 43.5889 7.70508 43.4043C7.88964 43.2197 8.14036 43.1163 8.40137 43.1162Z"
        fill="url(#paint18_radial_6612_10854)"
        stroke="url(#paint19_linear_6612_10854)"
        stroke-width="0.13125"
      />
      <defs>
        <radialGradient
          id="paint0_radial_6612_10854"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(12.6 18.9163 -6.3 14.9981 2.10156 5.23047)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_6612_10854"
          x1="8.40156"
          y1="5.23047"
          x2="8.40156"
          y2="24.1467"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#509EF0" stop-opacity="0.8" />
          <stop offset="1" stop-color="#4186CF" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_6612_10854"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(35.7 23.1 -17.85 18.3152 14.7031 2.10156)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <linearGradient
          id="paint3_linear_6612_10854"
          x1="32.5531"
          y1="2.10156"
          x2="32.5531"
          y2="25.2016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#509EF0" stop-opacity="0.8" />
          <stop offset="1" stop-color="#4186CF" />
        </linearGradient>
        <radialGradient
          id="paint4_radial_6612_10854"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(12.6 18.9163 -6.3 14.9981 37.8008 30.4336)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <linearGradient
          id="paint5_linear_6612_10854"
          x1="44.1008"
          y1="30.4336"
          x2="44.1008"
          y2="49.3499"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#509EF0" stop-opacity="0.8" />
          <stop offset="1" stop-color="#4186CF" />
        </linearGradient>
        <radialGradient
          id="paint6_radial_6612_10854"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(35.7 23.1 -17.85 18.3152 2.10156 27.3008)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <linearGradient
          id="paint7_linear_6612_10854"
          x1="19.9516"
          y1="27.3008"
          x2="19.9516"
          y2="50.4008"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#509EF0" stop-opacity="0.8" />
          <stop offset="1" stop-color="#4186CF" />
        </linearGradient>
        <radialGradient
          id="paint8_radial_6612_10854"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(6.3 2.1 -3.15 1.66502 24.1523 7.35156)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <linearGradient
          id="paint9_linear_6612_10854"
          x1="27.3023"
          y1="7.35156"
          x2="27.3023"
          y2="9.45156"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#509EF0" stop-opacity="0.8" />
          <stop offset="1" stop-color="#4186CF" />
        </linearGradient>
        <radialGradient
          id="paint10_radial_6612_10854"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(21 2.1 -10.5 1.66502 24.1523 12.6016)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <linearGradient
          id="paint11_linear_6612_10854"
          x1="34.6523"
          y1="12.6016"
          x2="34.6523"
          y2="14.7016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#509EF0" stop-opacity="0.8" />
          <stop offset="1" stop-color="#4186CF" />
        </linearGradient>
        <radialGradient
          id="paint12_radial_6612_10854"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(21 2.1 -10.5 1.66502 24.1523 17.8516)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <linearGradient
          id="paint13_linear_6612_10854"
          x1="34.6523"
          y1="17.8516"
          x2="34.6523"
          y2="19.9516"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#509EF0" stop-opacity="0.8" />
          <stop offset="1" stop-color="#4186CF" />
        </linearGradient>
        <radialGradient
          id="paint14_radial_6612_10854"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(6.3 2.1 -3.15 1.66502 22.0508 32.5508)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <linearGradient
          id="paint15_linear_6612_10854"
          x1="25.2008"
          y1="32.5508"
          x2="25.2008"
          y2="34.6508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#509EF0" stop-opacity="0.8" />
          <stop offset="1" stop-color="#4186CF" />
        </linearGradient>
        <radialGradient
          id="paint16_radial_6612_10854"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(21 2.1 -10.5 1.66502 7.35156 37.8008)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <linearGradient
          id="paint17_linear_6612_10854"
          x1="17.8516"
          y1="37.8008"
          x2="17.8516"
          y2="39.9008"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#509EF0" stop-opacity="0.8" />
          <stop offset="1" stop-color="#4186CF" />
        </linearGradient>
        <radialGradient
          id="paint18_radial_6612_10854"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(21 2.1 -10.5 1.66502 7.35156 43.0508)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB45F" />
          <stop offset="1" stop-color="#FF8700" />
        </radialGradient>
        <linearGradient
          id="paint19_linear_6612_10854"
          x1="17.8516"
          y1="43.0508"
          x2="17.8516"
          y2="45.1508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#509EF0" stop-opacity="0.8" />
          <stop offset="1" stop-color="#4186CF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ConversationIcon;
